export class CustomEqualityMap {
    constructor(equalityFn) {
        this.map = new Map();
        this.equalityFn = equalityFn || ((a, b) => a === b);
    }

    _findEntry(searchKey) {
        for (const [key, value] of this.map.entries()) {
            if (this.equalityFn(key, searchKey)) {
                return [key, value];
            }
        }
        return null;
    }

    set(key, value) {
        if (typeof key !== 'object' || key === null) {
            throw new TypeError('Key must be an object');
        }

        const entry = this._findEntry(key);
        if (entry) {
            this.map.set(entry[0], value);
        } else {
            this.map.set(key, value);
        }
    }

    get(key) {
        const entry = this._findEntry(key);
        return entry ? entry[1] : undefined;
    }

    has(key) {
        return this._findEntry(key) !== null;
    }

    delete(key) {
        const entry = this._findEntry(key);
        if (entry) {
            this.map.delete(entry[0]);
            return true;
        }
        return false;
    }

    keys() {
        return this.map.keys();
    }

    values() {
        return this.map.values();
    }

    entries() {
        return this.map.entries();
    }

    clear() {
        return this.map.clear();
    }

    get size() {
        return this.map.size;
    }
}
